/*=========================================================================================
  File Name: cart.js
  Description: Cart Local Storage
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

function storeCart(id, itemsInCart) {
    // let id = JSON.parse(localStorage.getItem('currentRestaurant'));
    console.log('storeCart is called!')
    localStorage.setItem(id, JSON.stringify(itemsInCart));
}

function getCart(id) {
    // let id = JSON.parse(localStorage.getItem('currentRestaurant'));
    let itemsInCart = localStorage.getItem(id);
    return JSON.parse(itemsInCart);
}

function clearCart(id) {
    // let id = JSON.parse(localStorage.getItem('currentRestaurant'));
    localStorage.removeItem(id);
}

export default {
    storeCart,
    getCart,
    clearCart
}